import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const getImageUrl = (item, size) => {
  return item.image_field
    ? flattenToAppURL(`${item['@id']}/@@images/${item.image_field}/${size}`)
    : flattenToAppURL(item?.image?.scales?.[size]?.download);
};

export default getImageUrl;
